import { render, staticRenderFns } from "./FileCrud.vue?vue&type=template&id=9a3d34c6&"
import script from "./FileCrud.vue?vue&type=script&lang=js&"
export * from "./FileCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports